import configuration from '@/configuration'
import ls from '@/utils/localstorage'

const state = {
  isMobile: false,
  sidebar: true,
  sidebarPage: ls.getSidebarPage() || 1,
  commander: false,
  pageChanging: false,
  haveUnreadAnnouncements: false,
  toggle: {
    featureKeyDebugger: false,
  },
  keepAlive: [],
  currentModule: [],
  siteKey: {
    v2: null,
    v3: null,
  },
}

const mutations = {
  SET_SITEKEY: (state, { version, value }) => {
    state.siteKey[version] = value
    console.log('SET_SITEKEY', state.siteKey)
  },
  SET_TOGGLE: (state, { key, toggle }) => {
    state.toggle[key] = toggle
  },
  SET_HAVE_UNREAD_ANNOUNCEMENTS: (state, toggle) => {
    state.haveUnreadAnnouncements = toggle
  },
  SHOW_COMMANDER: (state, toggle) => {
    state.commander = toggle
  },
  TOGGLE_PAGE_CHANGING: (state, toggle) => {
    state.pageChanging = toggle
  },
  TOGGLE_SIDEBAR: (state) => {
    state.sidebar = !state.sidebar
  },
  SET_SIDEBAR_PAGE: (state, sidebarPage) => {
    // 先更新記憶體狀態，確保即使 localStorage 寫入失敗（無痕模式／配額已滿）
    // 側邊欄層級仍正確；持久化採 best-effort，不讓例外往外拋而卡住路由 guard。
    state.sidebarPage = sidebarPage
    try {
      ls.setSidebarPage(sidebarPage)
    } catch (error) {
      console.error('[app] persist sidebarPage failed', error)
    }
  },
  SET_SIDEBAR: (state, status) => {
    state.sidebar = status
  },
  UPDATE_VIEW_WIDTH: (state, width) => {
    state.viewWidth = width
  },
  SET_MOBILE: (state, status) => {
    state.isMobile = status
  },
  SET_KEEP_ALIVE: (state, page) => {
    if (state.keepAlive.length > 1) state.keepAlive.shift()
    if (state.keepAlive.includes(page)) return
    state.keepAlive.push(page)
  },
  EMPTY_KEEP_ALIVE: (state) => {
    state.keepAlive = []
  },
  SET_CURRENT_MODULE (state, module) {
    // console.log('🔥🔥🔥 module', module)
    if (state.currentModule.includes(module)) return
    state.currentModule.push(module)
    // console.log('🔥🔥🔥 state.currentModule', state.currentModule)
  },
}

const actions = {
  toggleSidebar ({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  setSidebarPage ({ commit }, page) {
    commit('SET_SIDEBAR_PAGE', page)
  },
  setSidebar ({ commit }, status) {
    commit('SET_SIDEBAR', status)
  },
  setMobile ({ commit }, status) {
    commit('SET_MOBILE', status)
  },
  emptyKeepAlive ({ commit }) {
    commit('EMPTY_KEEP_ALIVE')
  },
}

const getters = {
  usePermissionsDebugger () {
    return ['dev', 'uat'].includes(configuration('appRuntime'))
  },
  useSidebarSearch () {
    return ['dev', 'uat'].includes(configuration('appRuntime'))
  },
  useRecentShops () {
    return ['dev', 'uat'].includes(configuration('appRuntime'))
  },
  useQuickAccountSwitcher () {
    return ['dev', 'uat'].includes(configuration('appRuntime'))
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
